import axios from "axios";
import type { DailyTagOut } from "@/pages/human-resources/time-management/endpoints/tags/inout/DailyTagOut.ts";
import type { HourlyTagOut } from "@/pages/human-resources/time-management/endpoints/tags/inout/HourlyTagOut.ts";

export async function getDomainDailyTags(
  domainId: string,
): Promise<DailyTagOut[]> {
  const { data } = await axios.get<DailyTagOut[]>(
    `/api/timeslotcategories/domains/${domainId}`,
  );
  return data;
}

export async function getSiteDailyTags(
  domainId: string,
  siteId: string,
): Promise<DailyTagOut[]> {
  const { data } = await axios.get<DailyTagOut[]>(
    `/api/timeslotcategories/domains/${domainId}/sites/${siteId}`,
  );
  return data;
}

export async function getHourlyTags(domainId: string): Promise<HourlyTagOut[]> {
  const { data } = await axios.get<HourlyTagOut[]>(
    `/api/timeslotcategories/domains/${domainId}/hourly`,
  );
  return data;
}
